import script from "./TheAccessData.vue?vue&type=script&setup=true&lang=js"
export * from "./TheAccessData.vue?vue&type=script&setup=true&lang=js"

import "./TheAccessData.vue?vue&type=style&index=0&id=53ca4851&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53ca4851"]])

export default __exports__